import Loadable from "react-loadable";

const AsyncLandingPage = Loadable({
  loader: () =>
    import(/* webpackChunkName: "landing-page" */ "./AsyncLandingPageRoute"),
  loading: () => null,
});

export default AsyncLandingPage;
